/**
 * @module ArticlesMiniList
 */

import Component from '../base/Component';
import './styles.css';

/**
 * Раздел UI Kit.
 */
export default class ArticlesMiniList extends Component {
    static className = 'articles-mini-list';
}
